//import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "./store.js";
import { Provider } from "react-redux";
import App from "./App.js";
import ThemeProvider from "./theme/ThemeProvider.js";
import { LayoutProvider } from "./context/layoutContext.js";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider>
                <LayoutProvider>
                    <App />
                </LayoutProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);
